import { NgModule } from '@angular/core';
import { DsTableComponent } from './ds-table.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ListNoItemsComponent } from './list-no-items/list-no-items.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { BasicModule } from '../basic/basic.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [DsTableComponent, ListNoItemsComponent],
  imports: [
    CommonModule,
    RouterModule,
    NgxPaginationModule,
    TranslateModule.forChild(),
    NgbCollapseModule,
    BasicModule,
  ],
  exports: [DsTableComponent, ListNoItemsComponent],
})
export class DsTableModule {}
